module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-underline-4865d0c1.svg";